(function () {
    'use strict';

    angular.module("imApp").factory("activityTypesService", ['$ihttp', function ($ihttp) {
        let service = {
            listActivityTypes: function (parms) {
                return $ihttp.post({
                    method: 49,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
